module.exports = {
  blogCategories: [
    { title: 'Foundations', slug: 'foundations' },
    { title: 'Product Updates', slug: 'product-updates' },
    { title: 'Company News', slug: 'company' },
  ],
}
